import { render, staticRenderFns } from "./CustomerAssetTemplatesManagerWidget.vue?vue&type=template&id=24e22ba8"
import script from "./CustomerAssetTemplatesManagerWidget.vue?vue&type=script&lang=js"
export * from "./CustomerAssetTemplatesManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports